module.exports = __webpack_public_path__ + "static/bg-24f2418466703770e7baa2019a917757.jpg";